/* Copyright (c) 2021-2022 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { CapacityBasedFeeTypeEnum } from "~/models/assignmentRule";

export const AssignmentRuleInitialState = {
  attachedServices: [
    {
      attachedSlas: [] || [
        {
          data: {
            comment: "",
            log: {
              created: {
                author: "",
                time: "",
              },
              modified: {
                author: "",
                time: "",
              },
            },
            value: "",
          },
          effectiveValue: "",
          sla: {
            description: "",
            id: "",
            name: "",
            range: {
              default: "",
              max: "",
              min: "",
              unit: "",
            },
            supportHours: "",
            type: "",
          },
        },
      ],
      attachedTools: null,
      service: {
        deactivated: false,
        id: "",
        name: "",
        version: "",
        pricingType: "",
        serviceGroup: null,
      },
    },
  ],
  attachedServiceLevel: {
    serviceLevel: {
      capacityBasedFee: {
        defaultPercentage: "",
        maxPercentage: "",
        minPercentage: "",
      },
      id: "",
      index: 0,
      name: "",
    },
    capacityBasedFeeType: CapacityBasedFeeTypeEnum.DEFAULT_TYPE,
    capacityBasedPercentageFee: "",
    effectiveCapacityBasedPercentageFee: "",
  },
  description: "",
  environmentStatus: "",
  evaluationStatus: "",
  environmentTypes: [""],
  id: "",
  name: "",
};
